import React from "react";
import { Select, Input } from "antd";

const InputOrSearch = ({showInput, showSearch, ...props}) => {

    const filterBy = (inputValue, option) => option.label.toUpperCase().includes(inputValue.toUpperCase())  || String(option.value).toUpperCase().includes(inputValue.toUpperCase());
    return showInput ?  <Input {...props}/> : <Select filterOption={filterBy} {...props} showSearch={showSearch}/>;
}

export default InputOrSearch;